import { Pagination } from "services/search";
import { DataWithPagination } from "services/api/types";
import { paginatedApiCall } from "services/api/createApiCall";

import { transformVehicleTransferRow } from "./transformations";
import { VehicleTransferRow, VehicleTransferSearchFormValues } from "./types";

/*---------------------------------------------------------------------------------------
  SEARCH — premještaji kroz sva vozila
-----------------------------------------------------------------------------------------*/
export const getVehicleTransfersAPI = async (
  pagination: Pagination,
  values: VehicleTransferSearchFormValues
): Promise<DataWithPagination<VehicleTransferRow>> => {
  let path = `/v1/fleet/vehicle-transfers?`;

  if (values.search) path += `&search=${encodeURIComponent(values.search)}`;
  if (values.locationType) path += `&locationType=${values.locationType}`;
  if (values.validFromFrom)
    path += `&validFromFrom=${values.validFromFrom.toISOString()}`;
  if (values.validFromTo) path += `&validFromTo=${values.validFromTo.toISOString()}`;
  if (values.isActive !== null) path += `&isActive=${values.isActive}`;

  return await paginatedApiCall(path, pagination, transformVehicleTransferRow);
};
